import { cn } from "@/utils/cn";
import ImageWithLoading from "../image-with-loading";

interface IAutoScaleImageProps {
  imageUri: string;
  blurBackground?: boolean;
  hasOverlay?: boolean;
  classNames?: {
    container?: string;
    image?: string;
  };
  children?: React.ReactNode;
  alt?: string;
}

export const AutoScaleImage = ({
  imageUri,
  blurBackground = true,
  hasOverlay = true,
  classNames,
  children,
  alt,
}: IAutoScaleImageProps) => {
  return (
    <div
      className={cn("relative bg-white overflow-hidden", classNames?.container)}
    >
      {blurBackground && (
        <ImageWithLoading
          src={imageUri}
          alt={`${alt} blur`}
          aria-hidden="true"
          classNames={{
            container: "absolute inset-0 w-full h-full z-0",
            image: "w-full h-full object-cover blur-lg scale-110",
          }}
        />
      )}
      <ImageWithLoading
        src={imageUri}
        alt={alt ?? ""}
        classNames={{
          container: cn(
            "relative w-full h-full bg-transparent z-5",
            classNames?.image,
          ),
          image: cn("w-full h-full object-contain", classNames?.image),
        }}
      />

      {hasOverlay && (
        <>
          <div className="absolute top-0 left-0 z-20 right-0 h-1/3 bg-gradient-to-b from-black/60 to-transparent pointer-events-none" />

          <div className="absolute bottom-0 left-0 z-20 right-0 h-1/3 bg-gradient-to-t from-black/60 to-transparent pointer-events-none" />
        </>
      )}

      {children}
    </div>
  );
};
